import { PageContentAtom, ToolbarMolecule } from '@justomx/atlas-components'

import LoaderAtom from 'components/atoms/Loader.atom'
import { StackAtom } from 'components/atoms/Stack.atom'
import { InstructionsMolecule } from 'components/molecule/Instructions.molecule'
import { ScannerMolecule } from 'components/molecule/Scanner.molecule'
import { TransferPalletCardOrganism } from 'components/organisms/TransferPalletCard.organism'
import { TransferProgressCard } from 'components/organisms/TransferProgressCard.organism'
import { useTransferPage } from './TransferPage.hook'

const TransferPage = () => {
  const { actions, docNum, palletsData, loading, totalSKUs, warehouse } =
    useTransferPage()

  return (
    <>
      {loading && <LoaderAtom>Cargando</LoaderAtom>}

      <ToolbarMolecule
        title="Traslado"
        actionIcon="ic_arrow_back"
        onAction={actions.onGoBack}
      />

      <PageContentAtom>
        <StackAtom $direction="column" $gap={24}>
          <TransferProgressCard
            docNum={docNum}
            warehouse={warehouse}
            palletsLabel={`${Object.values(palletsData).length}`}
            productsLabel={`${totalSKUs}/${totalSKUs}`}
          />

          <InstructionsMolecule
            ordered
            lines={[
              'Escanea la etiqueta y el canal de embarque.',
              'Coloca la tarima en el canal de embarque.'
            ]}
          />

          <StackAtom $direction="column" $gap={16}>
            {Object.values(palletsData).map((palletData, index) => (
              <TransferPalletCardOrganism
                key={palletData.container}
                channel={palletData.channel}
                container={palletData.container}
                palletNumber={index + 1}
                totalPallets={Object.values(palletsData).length}
                palletScanned={palletData.palletScanned}
                palletReady={palletData.palletReady}
                currentPallet={palletData.currentPallet}
              />
            ))}
          </StackAtom>
        </StackAtom>

        <ScannerMolecule mode="hidden" onScan={actions.onScan} />
      </PageContentAtom>
    </>
  )
}

export default TransferPage
